// =============================================================================
// SALES ADMIN AGENT - Utilise le pattern unifié CxOChatPanel
// =============================================================================
import CxOChatPanel from "../direction/CxOChatPanel";

export default function SalesAdminAgent() {
  return <CxOChatPanel cxoType="sales_admin" />;
}
